import createLocalesContext from 'app/helpers/createLocalesContext';

const { LocalesContext, useLocales, useAllLocales } = createLocalesContext();

export { LocalesContext, useLocales, useAllLocales };
